import { render } from "./PpcInconsistentStatePopover.vue?vue&type=template&id=ccb28dbc&scoped=true"
import script from "./PpcInconsistentStatePopover.vue?vue&type=script&lang=js"
export * from "./PpcInconsistentStatePopover.vue?vue&type=script&lang=js"

import "./PpcInconsistentStatePopover.vue?vue&type=style&index=0&id=ccb28dbc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb28dbc"]])

export default __exports__